module.exports = __webpack_public_path__ + "resources/img/img_dvision6_m.82ac5632cdd631b75e5a9d4d9098fad7.png";